// Cart bundle upsell (snippets/cart-upsell.liquid). Adds only the checked add-ons — never the anchor item.
class CartUpsell extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.button = this.querySelector('[data-add]');
    this.msg = this.querySelector('[data-msg]');
    // stopPropagation: Dawn's <cart-items> treats every bubbling change as a quantity edit.
    this.addEventListener('change', (event) => {
      event.stopPropagation();
      this.update();
    });
    this.button.addEventListener('click', () => this.add());
    this.update();
  }

  format(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: this.dataset.currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  picks() {
    return [...this.querySelectorAll('[data-addon]')].map((el) => {
      const input = el.querySelector('[data-variant]');
      const source = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      return {
        el,
        checked: el.querySelector('input[type="checkbox"]').checked,
        id: Number(input.value),
        price: Number(source.dataset.price),
        money: source.dataset.money,
      };
    });
  }

  update() {
    const picks = this.picks();
    picks.forEach((p) => {
      p.el.querySelector('[data-price-label]').textContent = p.money;
      p.el.classList.toggle('is-off', !p.checked);
    });
    const chosen = picks.filter((p) => p.checked);
    this.querySelector('[data-total]').textContent = this.format(chosen.reduce((sum, p) => sum + p.price, 0));
    this.button.disabled = chosen.length === 0;
  }

  async add() {
    const items = this.picks().filter((p) => p.checked).map((p) => ({ id: p.id, quantity: 1 }));
    if (!items.length) return;
    const drawer = this.closest('cart-drawer');
    const body = { items };
    if (drawer) body.sections = ['cart-drawer', 'cart-icon-bubble'];

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.msg.textContent = '';
    let error = this.dataset.error;
    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (res.ok && !data.status) {
        if (drawer) return drawer.renderContents(data);
        return window.location.reload();
      }
      // Shopify answers 422 with a description when stock runs out — show it as-is.
      error = data.description || data.message || error;
    } catch (e) {}
    this.msg.textContent = error;
    this.button.removeAttribute('aria-busy');
    this.button.disabled = false;
  }
}

if (!customElements.get('cart-upsell')) customElements.define('cart-upsell', CartUpsell);
